export default "__VITE_ASSET__CdKUty_r__"